<template>
  <div class="contract_data">
    <van-sticky>
      <van-nav-bar title="客户编辑" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-form
      label-width="140"
      :show-error="false"
      @submit="onSubmit"
      error-message-align="right"
    >
      <van-cell-group>
        <van-field input-align="right" label="头像" readonly>
          <template #button>
            <van-uploader
              v-model="fileList1"
              :max-count="1"
              :after-read="afterRead1"
              accept="image/*"
            />
          </template>
        </van-field>

        <van-field
          input-align="right"
          v-model="submitData.nickname"
          label="昵称"
          placeholder="请输入"
          is-link
          required
          :rules="[{ required: true, message: '请输入' }]"
        />

        <van-field
          input-align="right"
          v-model="submitData.fullName"
          label="姓名"
          placeholder="请输入"
          is-link
        />

        <van-field
          required
          input-align="right"
          v-model="submitData.gender_name"
          label="性别"
          placeholder="请选择性别"
          is-link
          @click="showSexsOptions = true"
          :rules="[{ required: true, message: '请选择性别' }]"
        />

        <van-action-sheet
          v-model="showSexsOptions"
          :actions="sexsOptions"
          @select="onSelectType"
        />

        <van-field
          input-align="right"
          v-model="submitData.birth"
          label="生日"
          placeholder="请输入"
          is-link
          readonly
          @click="showTime = true"
        />

        <van-action-sheet v-model="showTime">
          <van-datetime-picker
            type="date"
            title="请选择生日"
            :min-date="minDate"
            :max-date="maxDate"
            @change="changeShowTime"
            @confirm="confirmShowTime"
            :formatter="formatter"
            @cancel="showTime = false"
          />
        </van-action-sheet>

        <van-field
          required
          is-link
          input-align="right"
          v-model="submitData.contactNumber"
          label="联系电话"
          placeholder="请输入"
          :rules="[
            { required: true },
            { pattern: /^1[3456789]\d{9}$/, message: '电话格式错误！' },
          ]"
        />

        <van-field
          input-align="right"
          v-model="submitData.emergencyContactName"
          label="紧急联系人"
          placeholder="请输入"
          is-link
        >
        </van-field>

        <van-field
          required
          is-link
          input-align="right"
          v-model="submitData.emergencyContactPhone"
          label="紧急联系电话"
          placeholder="请输入"
          :rules="[
            { required: true },
            { pattern: /^1[3456789]\d{9}$/, message: '电话格式错误！' },
          ]"
        />

        <van-field
          required
          input-align="right"
          label="身份证"
          readonly
          class="idcard"
          :rules="[{ required: true, message: '请上传图片' }]"
        >
          <template #input>
            <!-- <div>身份证</div> -->
            <div class="idcard_img">
              <van-uploader
                :max-count="1"
                v-model="fileList2"
                :after-read="afterRead2"
                fit="contain"
              >
                <van-icon name="plus" size="30" color="#898989" />
                <div>上传正面照片</div>
              </van-uploader>
              <van-uploader
                fit="contain"
                :max-count="1"
                v-model="fileList3"
                :after-read="afterRead3"
              >
                <van-icon name="plus" size="30" color="#898989" />
                <div>上传反面照片</div>
              </van-uploader>
            </div>
          </template>
        </van-field>

        <van-field
          input-align="right"
          v-model="submitData.idCard"
          label="身份证号码"
          placeholder="请输入"
          is-link
          required
          :rules="[{ required: true, message: '请输入' }]"
        />

        <van-field
          required
          input-align="right"
          label="营业执照"
          readonly
          class="data_idcard"
          v-model="submitData.fileIdList"
          :rules="[{ required: true, message: '请上传营业执照' }]"
        >
          <template #input>
            <div class="idcard_img">
              <van-uploader
                :max-count="1"
                class="img_license"
                v-model="fileList4"
                :after-read="afterRead4"
              >
                <van-icon name="plus" size="40" color="#898989" />
                <div>上传营业执照照片</div>
              </van-uploader>
            </div>
          </template>
        </van-field>

        <van-field
          input-align="right"
          v-model="submitData.unifiedSocialCreditCode"
          label="统一社会信用代码"
          placeholder="请输入"
          is-link
          required
          :rules="[{ required: true, message: '请输入' }]"
        />

        <van-field
          input-align="right"
          v-model="submitData.company_official"
          label="公司名称"
          placeholder="请输入"
          is-link
          required
          :rules="[{ required: true, message: '请输入' }]"
        />

        <van-field
          input-align="right"
          v-model="submitData.company_legalPerson"
          label="法人姓名"
          placeholder="请输入"
          is-link
          required
          :rules="[{ required: true, message: '请输入' }]"
        />

        <van-field
          input-align="right"
          v-model="submitData.company_address"
          label="地址"
          placeholder="请输入"
          is-link
          required
          :rules="[{ required: true, message: '请输入' }]"
        />

        <van-field
          required
          input-align="right"
          label="合同文件"
          readonly
          class="data_idcard"
          v-model="submitData.contractFileIdList"
          :rules="[{ required: true, message: '请上传合同照片' }]"
        >
          <template #input>
            <div class="idcard_img">
              <van-uploader
                fit="fill"
                class="img_license"
                v-model="fileList5"
                :after-read="afterRead5"
                multiple
                :before-delete="deleteUploadImg"
              >
                <van-icon name="plus" size="40" color="#898989" />
                <div>上传合同照片（多张）</div>
              </van-uploader>
            </div>
          </template>
        </van-field>

        <van-field
          input-align="right"
          v-model="submitData.signTime"
          label="签约日期"
          placeholder="请选择"
          is-link
          @click="showData2 = true"
          readonly
          :rules="[{ required: true, message: '请选择' }]"
        />
        <van-calendar v-model="showData2" @confirm="onConfirmData2" />

        <van-field
          input-align="right"
          v-model="submitData.expirationTime"
          label="到期日期"
          placeholder="请选择"
          is-link
          @click="showData3 = true"
          readonly
          :rules="[{ required: true, message: '请选择' }]"
        />
        <van-calendar v-model="showData3" @confirm="onConfirmData3" />
      </van-cell-group>

      <van-button color="#0CA7F0" block>立即保存</van-button>
    </van-form>
  </div>
</template>

<script>
import {
  Button,
  Cell,
  Image,
  Uploader,
  Icon,
  Form,
  Field,
  CellGroup,
  Calendar,
  DatetimePicker,
  ActionSheet,
} from "vant";
import storage from "@/utils/storage";

export default {
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Calendar.name]: Calendar,
    [DatetimePicker.name]: DatetimePicker,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    return {
      submitData: {
        id: 0,
        portraitImageId: "",
        nickname: "", //昵称
        gender: "", //性别，1-男/2-女
        gender_name: "", //
        fullName: "", //姓名
        birth: "", //生日，格式：yyyy-MM-dd
        contactNumber: "", //联系电话
        emergencyContactName: "测试", //紧急联系人
        emergencyContactPhone: "", //紧急联系电话
        idCard: "", //身份证号
        unifiedSocialCreditCode: "", //统一社会信用代码
        company_official: "", //公司名称
        company_legalPerson: "", //法人姓名
        company_address: "", //地址
        idCard_front_fileId: "", //身份证号-正面附件id
        idCard_back_fileId: "", //身份证号-反面附件id
        businessLicense_fileId: "", //营业执照附件id
        signTime: "", //签订日期，格式：yyyy-MM-dd
        expirationTime: "", //到期日期，格式：yyyy-MM-dd
        contractFileIdList: [], //已上传合同附件ids
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      showData1: false,
      showData2: false,
      showData3: false,
      //性别
      showSexsOptions: false,
      sexsOptions: [
        { name: "男", value: 1 },
        { name: "女", value: 2 },
      ],

      minDate: new Date(1960, 0, 0),
      maxDate: new Date(),
      currentDate: new Date(2000, 0, 0),
      showTime: false,
      confirmTime: "",
    };
  },

  created() {
    this.submitData.id = this.$route.query.id;
    this.customerManagementDetail(this.$route.query.id);
  },

  methods: {
    customerManagementDetail(id) {
      var that = this;
      that.$api
        .customerManagementDetailAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            that.fileList1.push({ url: res.data.data.portrait });
            that.fileList2.push({ url: res.data.data.idCard_front });
            that.fileList3.push({ url: res.data.data.idCard_back });
            that.fileList4.push({ url: res.data.data.businessLicense });
            that.fileList5 = res.data.data.contractImageList;
            that.submitData = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //日期格式化
    formatDate(date) {
      return `${date.getFullYear()}-${
        date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
      }-${date.getDate()}`;
    },

    formatter(type, val) {
      if (type === "year") {
        return `${val}`;
      } else if (type === "month") {
        return `${val}`;
      } else if (type === "day") {
        return `${val}`;
      }
      return val;
    },

    changeShowTime(picker) {
      var time = picker.getValues();
      this.confirmTime = time[0] + "-" + time[1] + "-" + time[2];
    },

    confirmShowTime() {
      var that = this;
      setTimeout(function () {
        that.submitData.birth = that.confirmTime;
        that.showTime = false;
      }, 500);
    },

    onConfirmData2(date) {
      this.showData2 = false;
      this.submitData.signTime = this.formatDate(date);
    },

    onConfirmData3(date) {
      this.showData3 = false;
      this.submitData.expirationTime = this.formatDate(date);
    },

    afterRead1(files) {
      var that = this;
      that.uploadMultipartFileAPI(files, 1);
    },

    afterRead2(files) {
      var that = this;
      that.uploadMultipartFileAPI(files, 2);
    },

    afterRead3(files) {
      var that = this;
      that.uploadMultipartFileAPI(files, 3);
    },

    afterRead4(files) {
      var that = this;
      that.uploadMultipartFileAPI(files, 4);
    },

    afterRead5(files) {
      var that = this;
      that.uploadMultipartFileAPI(files, 5);
    },

    // 上传附件
    uploadMultipartFileAPI(file, type) {
      var that = this;
      var fileIdList = [];

      // 此时可以自行将文件上传至服务器
      const formData = new FormData();
      if (file instanceof Array) {
        //判断是否是数组
        file.map((element) => {
          formData.append("uploadfile", element.file);
        });
      } else {
        formData.append("uploadfile", file.file);
      }

      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      that.$axios
        .post(
          process.env.API_ROOT + "tgy/mobile/attachment/uploadMultipartFile",
          formData,
          {
            headers: {
              enctype: "multipart/form-data",
              Authorization: storage.getUserInfo(),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "上传成功",
              onClose() {
                res.data.dataList.forEach((element) => {
                  fileIdList.push(element.id);
                });
                if (type === 1) {
                  that.submitData.portraitImageId = fileIdList[0];
                } else if (type === 2) {
                  that.submitData.idCard_front_fileId = fileIdList[0];
                } else if (type === 3) {
                  that.submitData.idCard_back_fileId = fileIdList[0];
                } else if (type === 4) {
                  that.submitData.businessLicense_fileId = fileIdList[0];
                } else if (type === 5) {
                  that.submitData.contractFileIdList = fileIdList;
                }
              },
            });
          }
          console.log(res.data);
        });
    },

    onSubmit() {
      var that = this;
      that.$api
        .customerManagementSaveAPI(that.submitData)
        .then(function (res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "操作成功",
              onClose() {
                that.$router.go(-1);
              },
            });
          }else{
              that.$Notify({
              type: "danger",
              message: res.data.message,
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    // 选中类型
    onSelectType(item) {
      this.submitData.gender = item.value;
      this.submitData.gender_name = item.name;
      this.showSexsOptions = false;
    },

    deleteUploadImg(file, detail) {
      this.fileList5.splice(detail.index, 1);
      // var data = this.submitData.contractFileIdList;
      this.$delete(this.submitData.contractFileIdList, detail.index);
      // this.submitData.contractFileIdList = data;
    },
  },
};
</script>

<style lang="less" scoped>
.contract_data {
  /deep/ .van-uploader__upload {
    width: 50px;
    height: 50px;
  }

  /deep/ .van-cell {
    align-items: center !important;
  }

  .idcard {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    color: #323233;
    font-size: 14px;

    /deep/ .van-field__label {
      width: 94% !important;
    }

    /deep/ .van-field__value {
      width: 100%;
    }

    .idcard_img {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      width: 100%;

      .van-uploader {
        border-radius: 2px;
        background-color: rgba(0, 0, 0, 0.02);
        width: 150px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }

      /deep/ .van-uploader__wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
      }

      /deep/ .van-uploader__preview {
        margin: 0px;
      }

      /deep/ .van-uploader__preview-image {
        width: 100%;
        height: 100%;
      }

      .img_license {
        border-radius: 2px;
        background-color: rgba(0, 0, 0, 0.02);
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    }
  }

  .data_idcard {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    color: #323233;
    font-size: 14px;

    /deep/ .van-field__label {
      width: 94% !important;
    }

    /deep/ .van-field__value {
      width: 100%;
    }

    .idcard_img {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      width: 100%;

      /deep/ .van-uploader__input-wrapper {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        height: 150px;
        border-radius: 2px;
        background-color: rgba(0, 0, 0, 0.02);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
      }

      /deep/ .van-uploader__preview {
        margin: 0px;
        margin-top: 10px;
      }

      /deep/ .van-uploader__preview-image {
        width: 100%;
        height: 100%;
      }

      .img_license {
        width: 100%;
      }
    }
  }
  /deep/ .van-field__control {
    color: #979797;
  }

  .van-button {
    margin: auto;
    margin-top: 50px;
    font-size: 16px;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/place/clientEdit.vue